/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Account Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
import type { AccessLevelType } from './AccessLevelType';
import {
    AccessLevelTypeFromJSON,
    AccessLevelTypeFromJSONTyped,
    AccessLevelTypeToJSON,
} from './AccessLevelType';
import type { CountryCodeIso2 } from './CountryCodeIso2';
import {
    CountryCodeIso2FromJSON,
    CountryCodeIso2FromJSONTyped,
    CountryCodeIso2ToJSON,
} from './CountryCodeIso2';
import type { CurrencyCode } from './CurrencyCode';
import {
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import type { OrganisationStatus } from './OrganisationStatus';
import {
    OrganisationStatusFromJSON,
    OrganisationStatusFromJSONTyped,
    OrganisationStatusToJSON,
} from './OrganisationStatus';

/**
 *
 * @export
 * @interface OrganisationWithAccessLevelDto
 */
export interface OrganisationWithAccessLevelDto {
    /**
     *
     * @type {string}
     * @memberof OrganisationWithAccessLevelDto
     */
    organisationName?: string | null;
    /**
     *
     * @type {CountryCodeIso2}
     * @memberof OrganisationWithAccessLevelDto
     */
    region?: CountryCodeIso2;
    /**
     *
     * @type {OrganisationStatus}
     * @memberof OrganisationWithAccessLevelDto
     */
    status?: OrganisationStatus;
    /**
     *
     * @type {CurrencyCode}
     * @memberof OrganisationWithAccessLevelDto
     */
    currency?: CurrencyCode;
    /**
     *
     * @type {string}
     * @memberof OrganisationWithAccessLevelDto
     */
    id?: string;
    /**
     *
     * @type {AccessLevelType}
     * @memberof OrganisationWithAccessLevelDto
     */
    accessLevel?: AccessLevelType;
    /**
     *
     * @type {boolean}
     * @memberof OrganisationWithAccessLevelDto
     */
    hasApiAccess?: boolean;
}

/**
 * Check if a given object implements the OrganisationWithAccessLevelDto interface.
 */
export function instanceOfOrganisationWithAccessLevelDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrganisationWithAccessLevelDtoFromJSON(json: any): OrganisationWithAccessLevelDto {
    return OrganisationWithAccessLevelDtoFromJSONTyped(json, false);
}

export function OrganisationWithAccessLevelDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationWithAccessLevelDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        organisationName: !exists(json, 'organisation_name')
            ? undefined
            : json['organisation_name'],
        region: !exists(json, 'region') ? undefined : CountryCodeIso2FromJSON(json['region']),
        status: !exists(json, 'status') ? undefined : OrganisationStatusFromJSON(json['status']),
        currency: !exists(json, 'currency') ? undefined : CurrencyCodeFromJSON(json['currency']),
        id: !exists(json, 'id') ? undefined : json['id'],
        accessLevel: !exists(json, 'access_level')
            ? undefined
            : AccessLevelTypeFromJSON(json['access_level']),
        hasApiAccess: !exists(json, 'has_api_access') ? undefined : json['has_api_access'],
    };
}

export function OrganisationWithAccessLevelDtoToJSON(
    value?: OrganisationWithAccessLevelDto | null,
): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        organisation_name: value.organisationName,
        region: CountryCodeIso2ToJSON(value.region),
        status: OrganisationStatusToJSON(value.status),
        currency: CurrencyCodeToJSON(value.currency),
        id: value.id,
        access_level: AccessLevelTypeToJSON(value.accessLevel),
        has_api_access: value.hasApiAccess,
    };
}
